import React__default from 'react';
import { StandardHeroWithNavContentBelow } from './standard-hero-with-nav-content-below.component.js';
import { BoundedContent } from '../bounded-content/bounded-content.component.js';
import { renderWithRef } from '../core/render-with-ref.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var propTypes = {};
var StandardHeroWithNavContent = renderWithRef('StandardHeroWithNavContent', propTypes, function (props, ref) {
  return /*#__PURE__*/React__default.createElement(BoundedContent, _object_spread({
    ref: ref
  }, props), /*#__PURE__*/React__default.createElement(StandardHeroWithNavContentBelow, null, props.children));
});
export { StandardHeroWithNavContent };